import { motion } from "framer-motion";

// Kinetic masked line-by-line reveal for hero headings
export function RevealHeading({ lines, className = "", delay = 0.2 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Scroll-triggered reveal wrapper
export function Reveal({ children, className = "", delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Label({ children, className = "" }) {
  return (
    <span
      className={`text-xs font-semibold tracking-[0.28em] uppercase text-gold ${className}`}
    >
      {children}
    </span>
  );
}
